import { connect } from 'react-redux';
import ScribeSpeechTrainingSelector from './ScribeSpeechTrainingSelector';

const mapStateToProps = ({
  firebase: { user: firebaseUser },
  scribeConversation: { conversationRequested, conversationStarted },
  scribeTrainings,
}) => ({
  firebaseUser,
  conversationStarted,
  conversationRequested,
  scribeTrainings,
});

export default connect(mapStateToProps)(ScribeSpeechTrainingSelector);
